import { render, staticRenderFns } from "./Difference.vue?vue&type=template&id=b79d67a0&"
import script from "./Difference.vue?vue&type=script&lang=js&"
export * from "./Difference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports